
var $ = require('../../../../../../webpack/node_modules/jquery');
var tohighlight = "";
var tohighlightLi = "";
var tohighlightill = "";

$(document).ready(function(){

    //$('.torso_quicklinks ul li:not(:has(a))').each(function() {
    //    $(this).children().addClass('empty').prepend( "<p> </p>" );
    //});
    //var emptyOrgan = $(this).find('a').data("organ");
    //var emptyIllness = $(this).find('a').data("ill");

// execute if obesity exists
    if($('.torso_container').length){

        // hover effect on organs, resp. ilnness when hover over li elements
        $('.torso_quicklinks li').hover(function() {

                tohighlight = $(this).find('div').data("organ");
                tohighlightill = $(this).find('div').data("ill");
                if(tohighlight == "obesity"){
                    //$('.torso_img').find('#'+tohighlight).show();
                    $('.st0').addClass('obese');
                }else{
                    $('.torso_img').find('#'+tohighlight+' path').not("g.nocolor path").css('fill', '#AE3665');
                    $('#'+tohighlightill).removeClass('illness_invisible');
                }
            },
            function(){
                if(tohighlight == "obesity"){
                    //$('.torso_img').find('#'+tohighlight).hide();
                    $('.st0').removeClass('obese');
                }else{
                    $('.torso_img').find('#'+tohighlight+' path').not("g.nocolor path").css('fill', '');
                    $('#'+tohighlightill).addClass("illness_invisible");
                }
            });

        // hover effect on li when hover over organs and body (not over illness)
        $('.torso_img svg > g').hover(function() {
                // get id, it's the same as the data-organ attr
                var tohighlightLi = $(this).attr("id");

                $(this).on( "click", function() {
                    tohref = $('*[data-organ="'+tohighlightLi+'"]').attr('href');
                    window.location.href = tohref;
                });

                // if hover on default obesity will show up
                if($(this).attr("id") == "default" ){
                    //$(this).parent().find("#obesity").show();
                    $('*[data-organ="obesity"]').parent().addClass("active");
                    $('.st0').addClass('obese');
                    // otherwise the organs will light up
                }else{
                    $(this).find("path").not("g.nocolor path").css('fill', '#AE3665');
                    $('*[data-organ="'+tohighlightLi+'"]').parent().addClass("active");
                }
            },

            // mouseout logic
            function(){
                var tohighlightLi = $(this).attr("id");
                // remove the active state from li
                $('*[data-organ="'+tohighlightLi+'"]').parent().removeClass("active");
                // remove obesity
                if($(this).attr("id") == "default" ){
                    //$(this).parent().find("#obesity").hide();
                    $('*[data-organ="obesity"]').parent().removeClass("active");
                    $('.st0').removeClass('obese');
                }else{
                    $(this).find("path").not("g.nocolor path").css('fill', '');
                }
            });
    }
})
